function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import useAxios from "../../../../../Hooks/use-axios";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var restrictedChars = /[`!£#$%&()*+₹;<|=>^~?]/g;
function Address(_ref) {
  var deal = _ref.deal,
    formData = _ref.formData,
    setFormData = _ref.setFormData,
    name = _ref.name,
    nameChangedHandler = _ref.nameChangedHandler,
    nameBlurHandler = _ref.nameBlurHandler,
    nameHasError = _ref.nameHasError,
    nameIsValid = _ref.nameIsValid,
    Pin = _ref.Pin,
    PinChangedHandler = _ref.PinChangedHandler,
    PinHasError = _ref.PinHasError,
    PinBlurHandler = _ref.PinBlurHandler,
    PinIsValid = _ref.PinIsValid,
    phoneNumber = _ref.phoneNumber,
    phoneChangedHandler = _ref.phoneChangedHandler,
    phoneBlurHandler = _ref.phoneBlurHandler,
    phoneHasError = _ref.phoneHasError,
    phoneNumberIsValid = _ref.phoneNumberIsValid,
    mobileNumberIsValid = _ref.mobileNumberIsValid,
    mobile = _ref.mobile,
    setMobile = _ref.setMobile,
    mobileHasError = _ref.mobileHasError,
    onChange = _ref.onChange,
    validator = _ref.validator,
    setIsTouched = _ref.setIsTouched,
    setInputFocused = _ref.setInputFocused;
  var _useAxios = useAxios({}),
    loadingSimilarDeals = _useAxios.isLoading,
    fetchPin = _useAxios.sendExternalRequest;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    disableForm = _useState2[0],
    setDisableForm = _useState2[1];
  var handleChange = function handleChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    var UpdatedValue = name === "address" ? value.replace(restrictedChars, " ") : value;
    setFormData(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, name, UpdatedValue));
    });
    console.log("Form Data:", formData);
  };
  useEffect(function () {
    //Fetch address details based on pin code
    if (/^\d{6}$/.test(Pin)) {
      setDisableForm(false);
      var url = "https://api.postalpincode.in/pincode/".concat(Pin);
      var method = "GET";
      fetchPin({
        isEncryptedResponse: false,
        url: url,
        method: method
      }, function (res) {
        var _res$data$;
        if (res.status === 200 && (res === null || res === void 0 || (_res$data$ = res.data[0]) === null || _res$data$ === void 0 || (_res$data$ = _res$data$.PostOffice) === null || _res$data$ === void 0 ? void 0 : _res$data$.length) > 0) {
          var _res$data$2;
          var postOffice = res === null || res === void 0 || (_res$data$2 = res.data[0]) === null || _res$data$2 === void 0 ? void 0 : _res$data$2.PostOffice[0];
          setFormData(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              city: postOffice.District,
              state: postOffice.State
            });
          });
          setDisableForm(true);
        } else {
          setDisableForm(false);
          setFormData(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              city: "",
              state: ""
            });
          });
        }
      });
    }
  }, [Pin]);
  return /*#__PURE__*/_jsxs("div", {
    className: " flex flex-col justify-center",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "font-medium text-primary",
        children: "Ready to Redeem your product?"
      }), /*#__PURE__*/_jsx("h1", {
        className: "font-bold text-lg",
        children: "Contact Details"
      }), /*#__PURE__*/_jsx("h2", {
        className: "  text-sm",
        children: "Enter the details of the person receiving the order."
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-4",
      children: /*#__PURE__*/_jsxs("form", {
        className: "pt-2 pb-5",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "mb-6",
          children: [/*#__PURE__*/_jsxs("label", {
            className: "block text-sm font-medium text-gray-700",
            children: ["Name", /*#__PURE__*/_jsx("span", {
              className: "text-red-400",
              children: " *"
            })]
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            className: "mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm",
            onChange: nameChangedHandler,
            onBlur: nameBlurHandler,
            value: name,
            autoComplete: "off"
          }), nameHasError && /*#__PURE__*/_jsx("p", {
            className: "mt-1 text-left text-red-400 text-sm",
            children: "Please enter a valid Name"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: " w-full flex flex-col mx-auto relative",
          children: [/*#__PURE__*/_jsxs("label", {
            className: "block mb-1 text-sm font-medium text-gray-700 ",
            children: ["Phone number", /*#__PURE__*/_jsx("span", {
              className: "text-red-400",
              children: " *"
            })]
          }), /*#__PURE__*/_jsx(PhoneInput
          // disabled={isOtpSent}
          , {
            country: "in",
            countryCodeEditable: false,
            containerClass: "peer py-3 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full  h-11 placeholder-transparent",
            containerStyle: {
              width: "100%",
              border: "2px solid grey !important",
              outline: "none"
            },
            buttonStyle: {
              backgroundColor: "white",
              border: "none"
            },
            inputStyle: {
              width: "100%",
              height: "auto",
              border: "none",
              outline: "none",
              paddingLeft: "44px",
              fontSize: "16px"
            },
            isValid: validator,
            onChange: onChange,
            value: mobile,
            placeholder: "Phone",
            enableSearch: true,
            onBlur: function onBlur() {
              setIsTouched(true);
              setInputFocused(false);
            },
            onFocus: function onFocus() {
              return setInputFocused(true);
            },
            inputClass: "border border-gray-300"
          }), mobileHasError && /*#__PURE__*/_jsx("p", {
            className: " text-left text-sm mt-1 text-red-400",
            children: "Please enter a valid number"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "mb-6 mt-6",
          children: [/*#__PURE__*/_jsx("label", {
            className: "block text-sm font-medium text-gray-700",
            children: "Alternate Mobile Number"
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            onChange: phoneChangedHandler,
            onBlur: phoneBlurHandler,
            value: phoneNumber,
            autoComplete: "off",
            className: "mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm  "
          }), phoneHasError && /*#__PURE__*/_jsx("div", {
            className: "",
            children: /*#__PURE__*/_jsx("p", {
              className: "text-left text-sm  text-red-400 mt-1",
              children: "Please enter a valid phone Number"
            })
          })]
        }), /*#__PURE__*/_jsx("h1", {
          className: "font-bold text-lg mb-4",
          children: "Delivery Address"
        }), /*#__PURE__*/_jsxs("div", {
          className: "mb-6",
          children: [/*#__PURE__*/_jsxs("label", {
            className: "block text-sm font-medium text-gray-700",
            children: ["Address (House No, Building, Street, Area)", /*#__PURE__*/_jsx("span", {
              className: "text-red-400",
              children: " *"
            })]
          }), /*#__PURE__*/_jsx("textarea", {
            type: "text",
            name: "address",
            className: "mt-1 block  w-full text-grey-900 h-16 lg:h-12 xl:h-16 rounded-md p-2 border-[#BFBFBF] focus:border-[#BFBFBF] outline-none border-[1px]",
            value: formData.address,
            onChange: handleChange,
            maxLength: "200",
            placeholder: "Maximum 200 characters"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex mb-6",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "w-1/2 pr-2",
            children: [/*#__PURE__*/_jsxs("label", {
              className: "block text-sm font-medium text-gray-700",
              children: ["Locality / Town", /*#__PURE__*/_jsx("span", {
                className: "text-red-400",
                children: " *"
              })]
            }), /*#__PURE__*/_jsx("input", {
              type: "text",
              name: "locality",
              value: formData.locality,
              onChange: handleChange,
              className: "mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "w-1/2 pl-2",
            children: [/*#__PURE__*/_jsxs("label", {
              className: "block text-sm font-medium text-gray-700",
              children: ["Pincode", /*#__PURE__*/_jsx("span", {
                className: "text-red-400",
                children: " *"
              })]
            }), /*#__PURE__*/_jsx("input", {
              className: "mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm",
              type: "text",
              value: Pin,
              onChange: function onChange(e) {
                PinChangedHandler(e);
              },
              maxLength: 6,
              onBlur: PinBlurHandler
            }), PinHasError && /*#__PURE__*/_jsx("p", {
              className: "text-left text-red-400 text-sm mt-1",
              children: "Please enter a valid pin"
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex mb-6",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "w-1/2 pr-2",
            children: [/*#__PURE__*/_jsxs("label", {
              className: "block text-sm font-medium text-gray-700",
              children: ["City / District", /*#__PURE__*/_jsx("span", {
                className: "text-red-400",
                children: " *"
              })]
            }), /*#__PURE__*/_jsx("input", {
              type: "text",
              name: "city",
              value: formData.city,
              disabled: disableForm,
              onChange: handleChange,
              className: "mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "w-1/2 pl-2",
            children: [/*#__PURE__*/_jsxs("label", {
              className: "block text-sm font-medium text-gray-700",
              children: ["State", /*#__PURE__*/_jsx("span", {
                className: "text-red-400",
                children: " *"
              })]
            }), /*#__PURE__*/_jsx("input", {
              type: "text",
              name: "state",
              value: formData.state,
              disabled: disableForm,
              onChange: handleChange,
              className: "mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            })]
          })]
        })]
      })
    })]
  });
}
export default Address;